import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

// This one is done
const InfoWeCollect = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Information We Collect</h3>
      {/* Personal Information Section */}
      <h4>Personal Information</h4>
      <p>We collect the following personal information:</p>
      <ul>
        <li>
          Contact Data: First and last name, phone number, billing address,
          email, and company of employment (collected during signup, payment, or
          company registration).
        </li>
        <li>
          Newsletter: Your email address when you subscribe to our newsletter.
        </li>
      </ul>
      {/* Device Information Section */}
      <h4>Device Information</h4>
      <p>
        When you visit our site, we automatically collect certain information
        about your device and how you interact with the site. This includes:
      </p>
      <ul>
        <li>Your IP address, browser type, and time zone.</li>
        <li>
          Details about the pages you visit, the websites or search terms that
          referred you to our site, and how you interact with the site.
        </li>
      </ul>
      <p>We collect Device Information using the following technologies:</p>
      <ul>
        <li>
          <strong>Cookies:</strong> Data files placed on your device or computer
          that include an anonymous unique identifier. For more information
          about cookies and how to disable them, visit{' '}
          <a
            href="http://www.allaboutcookies.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://www.allaboutcookies.org
          </a>
          .
        </li>
        <li>
          <strong>Log Files:</strong> Track actions occurring on the site and
          collect data such as your IP address, browser type, pages visited, and
          time spent on those pages.
        </li>
      </ul>

      {/* Order Information Section */}
      <h4>Order Information</h4>
      <p>
        When you make a purchase or attempt to make a purchase through our site,
        we collect the following information:
      </p>
      <ul>
        <li>Your name, billing address, and shipping address.</li>
        <li>
          Payment information (e.g., credit card numbers, PayPal details).
        </li>
        <li>Your email address and phone number.</li>
      </ul>
    </PrivacyPolicyContainer>
  );
};

export default InfoWeCollect;
